import angular from 'angular';
import { TransitionDrawerComponent } from './transition-drawer.component';

const MODULE_NAME = 'core.component.layout.transition-drawer';

angular.module(MODULE_NAME, []).component('esTransitionDrawer', TransitionDrawerComponent);

export default MODULE_NAME;
